import axiosInstance from "../axiosInterceptor";

export async function getHomeWorkHelpQuestionById(questionId) {
  const response = await axiosInstance.get(
    `student/homeworkHelp/getQuestionDetailByID/${questionId}`
  );
  const data = response?.data;
  return data;
}
